class SocialCategoryService {

  constructor(ApiService, SocialCategorySchema) {
    this.ApiService = ApiService;
    this.SocialCategorySchema = SocialCategorySchema;
    this.socialCategoryEndpoint = '/api/socialcategories';
  }

  getCategories() {
    var self = this;

    return self.ApiService.get(self.socialCategoryEndpoint)
        .then( (response) => { return response.data } );
  }

  addHashtag(hashtagObj) {
    var self = this;

    return self.ApiService.post(self.socialCategoryEndpoint+'/hashtags', hashtagObj)
        .then( (response) => { return response.data } );
  }

  removeHashtag(socialCategoryId, hashtagId) {
    var self = this;

    return self.ApiService._delete(self.socialCategoryEndpoint+'/'+socialCategoryId+'/hashtags/'+hashtagId);
  }

}
SocialCategoryService.$inject = ['ApiService', 'SocialCategorySchema'];
export default SocialCategoryService;
